"use strict";
import { useContext } from "react";
import { ShellContext } from "../context";
export function useModules() {
  const { modules } = useContext(ShellContext);
  return modules;
}
